import { Typography, Modal, Button, Form } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Editor } from '../../tabs/Documentation/components/editor/Editor';
import { ANTD_GRAY } from '../../constants';
import { useTranslation } from '../../../../../i18n/useTranslation';

const StyledEditor = styled(Editor)`
    border: 1px solid ${ANTD_GRAY[4.5]};
`;

const StyledViewer = styled(Editor)`
    .remirror-editor.ProseMirror {
        padding: 0;
    }
`;

type Props = {
    title: string;
    description?: string | undefined;
    original?: string | undefined;
    onClose: () => void;
    onSubmit: (description: string) => void;
    isAddDesc?: boolean;
};

export default function UpdateDescriptionModal({ title, description, original, onClose, onSubmit, isAddDesc }: Props) {
    const { t } = useTranslation();
    const [updatedDesc, setDesc] = useState(description || original || '');
    const isDescValid = updatedDesc.replace(/(&nbsp;|\n)/g, '').length === 0 || updatedDesc === description;

    return (
        <Modal
            title={title}
            visible
            className="f-modal"
            centered
            onCancel={onClose}
            okText={isAddDesc ? t('Submit') : t('Update')}
            footer={
                <>
                    <Button onClick={onClose} type="default" className="ant-btn-default">
                        {t('Cancel')}
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => onSubmit(updatedDesc)}
                        disabled={isDescValid}
                        data-testid="description-modal-update-button"
                    >
                        {t('Update')}
                    </Button>
                </>
            }
        >
            <Form layout="vertical">
                <Form.Item>
                    <StyledEditor content={updatedDesc} onChange={setDesc} />
                </Form.Item>
                {!isAddDesc && description && original && (
                    <Form.Item label={<Typography.Text className="f-label">{t('Original:')}</Typography.Text>}>
                        <StyledViewer content={original || ''} readOnly />
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
}
